import React, { useState, useEffect } from "react";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Customer(props) {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();
  const allFields = watch();
  // console.log("selectedItem", selectedItem);

  // get customers
  const getCustomers = () => {
    setIsLoading(true);
    apiReq(url.GET_CUSTOMER, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setCustomers(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCustomers();
  }, []);

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // TODO: columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      sorter: (a, b) => a.rating.localeCompare(b.rating),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      sorter: (a, b) => a.content.localeCompare(b.content),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          <button
            className="btn btn-success btn-sm mr-2"
            onClick={() => handleEdit(record)}
          >
            <i className="ri-pencil-line"></i>
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(record._id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_CUSTOMER + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire({
                title: "Deleted!",
                text: res.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              getCustomers();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_CUSTOMER,
        {
          name: data.name,
          content: data.content,
          designation: data.designation,
          rating: data.rating,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getCustomers();
            setIsOpenModal(false);
            setSelectedItem(null);
            reset();
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_CUSTOMER + selectedItem._id,
        {
          name: data.name,
          content: data.content,
          designation: data.designation,
          rating: data.rating,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getCustomers();
            setSelectedItem(null);
            setIsOpenModal(false);
            reset();
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Handle edit category
  const handleEdit = (item) => {
    setSelectedItem(item);
    setValue("name", item.name);
    setValue("rating", item.rating);
    setValue("designation", item.designation);
    setValue("content", item.content);
    setIsOpenModal(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null
              ? "Update customer details"
              : "Add new customer"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("name", { required: true })}
                />
                {errors.name && (
                  <span className="text-danger">Name is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Designation</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("designation", { required: true })}
                />
                {errors.designation && (
                  <span className="text-danger">Designation is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>
                  content{" "}
                  <small className="text-muted" style={{ opacity: 0.5 }}>
                    ({allFields?.content?.length} / 140)
                  </small>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  {...register("content", { required: true })}
                />
                {errors.content && (
                  <span className="text-danger">Content is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Rating</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("rating", {
                    required: "Rating is required",
                    max: {
                      value: 5,
                      message: "Rating must be less than 5",
                    },
                  })}
                />
                {errors.rating && (
                  <span className="text-danger">{errors.rating.message}</span>
                )}
              </div>
              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Customers</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => setIsOpenModal(!isOpenModal)}
                    >
                      Add new customer
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={customers}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Customer;
